import { useCallback, useEffect, useMemo } from 'react';
import {
  isB2BPrinter,
  isStock,
  isWarehouseManager,
} from 'modules/user-has-permission/user-has-permission';
import { getEfficiency } from 'services/users.service';
import KPI from 'components/KPI/KPI';
import { useApp } from 'context/AppProvider';

export default function EfficiencyKPI() {
  const { menuIsOpen, efficiency, setEfficiency } = useApp();
  const mustShow = useMemo(
    () => isB2BPrinter() && !isStock() && !isWarehouseManager() && menuIsOpen,
    [menuIsOpen],
  );

  const fetchEffiency = useCallback(async () => {
    const { data: efficiency } = await getEfficiency();
    const preparedData = new Intl.NumberFormat('es-ES').format(
      (efficiency?.efficiency || 0).toFixed(1),
    );
    setEfficiency(preparedData);
  }, [setEfficiency]);

  useEffect(() => {
    let intervalId = null;
    (async () => {
      if (!mustShow) return;
      await fetchEffiency();
      intervalId = setInterval(async () => {
        const currentMinutes = new Date().getMinutes();
        if (currentMinutes === 0) await fetchEffiency();
      }, 60000);
    })();

    return () => {
      clearInterval(intervalId);
    };
  }, [mustShow, fetchEffiency]);

  return mustShow && efficiency !== undefined ? (
    <KPI
      title="Productividad"
      value={efficiency}
      label="bultos/hora"
      icon="stopwatch"
    />
  ) : null;
}
